import { useMutation } from 'react-query';

import { SOURCE_API_ROUTES } from '@/api-routes';
import { axiosInstance } from '@/axios';
import { useRefetchAllFeedsCategoryTabs } from '@/hooks/query/useFetchCategoryTabs';

import { useRefetchPublicSourceFeeds } from './useFetchPublicSourceFeeds';

type MutationData = {
  sourceId: string;
  boards: string[];
};

export const useAddPublicSourceToFeeds = () => {
  const refetchPublicSourceFeeds = useRefetchPublicSourceFeeds();
  const refetchAllFeedsCategoryTabs = useRefetchAllFeedsCategoryTabs();

  return useMutation(
    ({ sourceId, boards }: MutationData) =>
      axiosInstance.post(SOURCE_API_ROUTES.publicSourceBoards(sourceId), {
        boards,
      }),
    {
      onSettled: async (_, __, { sourceId }) => {
        await refetchPublicSourceFeeds(sourceId);
        refetchAllFeedsCategoryTabs();
      },
    }
  );
};
